module.exports = __webpack_public_path__ + "static/img/ic_font_logo.13550310.png";